"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditIcon = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("@emotion/react");
const EditIcon = (_a) => {
    var { color } = _a, props = __rest(_a, ["color"]);
    const theme = (0, react_1.useTheme)();
    return ((0, jsx_runtime_1.jsx)("svg", Object.assign({ width: 26, height: 24, viewBox: "0 0 26 24", fill: "none" }, props, { children: (0, jsx_runtime_1.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M20.607 2.678a1.101 1.101 0 00-1.47 0l-12.892 11.9a.955.955 0 00-.24.348l-1.824 4.57c-.306.767.503 1.514 1.335 1.23l4.95-1.683c.141-.048.27-.123.376-.221L23.734 6.92a.908.908 0 000-1.357l-3.127-2.886zm.798 3.565l-1.532-1.415L7.616 16.142l-1.532 2.829 3.064-1.415L21.405 6.243z", fill: color !== null && color !== void 0 ? color : theme.colors.grey90 }) })));
};
exports.EditIcon = EditIcon;
//# sourceMappingURL=edit_icon.js.map